<template>
    <div class="page-statistics">
        <crumbs></crumbs>
        <div class="filters-container">
            <CheckedSelect v-model="filters.saleUserId" :options="mySaleUserOptions" label="销售人员" @change="initData" />
            <CheckedSelect v-model="filters.productId" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" @change="initData" />
            <CheckedSelect v-model="filters.year" :options="yearOptions.slice(1)" label="年份选择" @change="initData" />
            <div class="prompt">合同更新日期：<b>{{ covenantLatestTime }}</b><br />开票更新日期：<b>{{ invoiceLatestTime }}</b></div>
        </div>
        <div class="statistics-container">
            <el-row :gutter="10" style="height: 420px;" v-loading="loadTrend">
                <el-col :span="17">
                    <div class="statis-wrap">
                        <!-- 标题+筛选 -->
                        <div class="title-line" style="margin-bottom: 15px;">
                            <div class="title">历年合同统计</div>
                            <CardSwitch v-model="trendMonthFlag" :styleType="2" :options="[{id:1,name:'月度'}, {id:0,name:'年度'}]" @change="fetchOveryearTrend" />
                            <!-- 图表切换 -->
                            <CardSwitch v-model="trendSwitch" :styleType="1" :options="[{id:'table',name:'表格'}, {id:'bar',name:'柱状图'}]">
                                <template v-slot:prefix="{ item }">
                                    <svg-icon v-if="item.id === 'table'" icon-class="biaoge" />
                                    <svg-icon v-else-if="item.id === 'bar'" icon-class="zhuzhe" />
                                </template>
                            </CardSwitch>
                        </div>
                        <!-- 表格 -->
                        <el-table :data="getTrendTableData" max-height="328px" :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }"
                            v-if="trendSwitch === 'table'">
                            <el-table-column prop="value" :label="trendMonthFlag === 1 ? '月份' : '年份'" min-width="60">
                                <template slot-scope="{row}">{{ (trendMonthFlag === 1 && row.value !== '合计') ? `${row.value}月` : row.value }}</template>
                            </el-table-column>
                            <el-table-column prop="customerCount" label="合同数量(份)" min-width="100">
                                <template slot-scope="{row}">
                                    <span class="link" @click="showCovenantDetail(row.value)">{{ row.customerCount }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contractPrice" label="合同金额(万元)" min-width="120">
                                <template slot-scope="{row}">
                                    <span class="link" @click="showCovenantDetail(row.value)">{{ row.contractPrice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invoicePrice" label="合同已开票(万元)" min-width="120">
                                <template slot-scope="{row}">
                                    <span class="link" @click="showCovenantDetail(row.value, [1,2])">{{ row.invoicePrice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="notInvoicePrice" label="合同未开票(万元)" min-width="120">
                                <template #header>
                                    <span style="color: #f53f3f">合同未开票(万元)</span>
                                </template>
                                <template slot-scope="{row}">
                                    <span :style="{'color': row.notInvoicePrice > 0 ? '#f53f3f' : '#606266', 'cursor': 'pointer'}"
                                        @click="showCovenantDetail(row.value, [0,2])">{{ row.notInvoicePrice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="yearInvoicePrice" :label="`当${trendMonthFlag === 1 ? '月' : '年'}总开票(万元)`" min-width="140">
                                <template slot-scope="{row}">
                                    <span class="link" @click="showInvoiceDetail(0, row.value)">{{ row.yearInvoicePrice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="receivePrice" :label="`当${trendMonthFlag === 1 ? '月' : '年'}开票到账(万元)`" min-width="140">
                                <template slot-scope="{row}">
                                    <span class="link" @click="showInvoiceDetail(0, row.value, 1)">{{ row.receivePrice }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="notPayPrice" min-width="150">
                                <template #header>
                                    <span style="color: #f53f3f">当{{ trendMonthFlag === 1 ? '月' : '年' }}开票未到账(万元)</span>
                                </template>
                                <template slot-scope="{row}">
                                    <span :style="{'color': row.notPayPrice > 0 ? '#f53f3f' : '#606266', 'cursor': 'pointer'}"
                                        @click="showInvoiceDetail(0, row.value, 0)">{{ row.notPayPrice }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 折线+柱状图 -->
                        <lineBarChar v-else-if="trendSwitch === 'bar'" id="overviewLineChar" :charData="trendChartData" height="330px" />
                    </div>
                </el-col>
                <el-col :span="7">
                    <!-- 模块：成交金额 -->
                    <div class="statis-wrap full-card" style="background: #3F9EFF;">
                        <div @click="showCovenantDetail('')">
                            <img src="~@/assets/image/statistics/icon-custom.png">
                            <label>当年合同数量</label>
                            <span class="value" style="font-size: 22px;">{{ price.count }}</span>
                            <span class="unit">份</span>
                        </div>
                        <div @click="showCovenantDetail('')">
                            <img src="~@/assets/image/statistics/icon-contract.png">
                            <label>当年合同金额</label>
                            <span class="value">￥<el-statistic group-separator="," :precision="2" :value="price.contract" /></span>
                            <span class="unit">元</span>
                        </div>
                        <div @click="showInvoiceDetail(0)">
                            <img src="~@/assets/image/statistics/icon-invoice.png">
                            <label>当年总开票</label>
                            <span class="value">￥<el-statistic group-separator="," :precision="2" :value="price.invoice" /></span>
                            <span class="unit">元</span>
                        </div>
                        <div @click="showInvoiceDetail(1)">
                            <img src="~@/assets/image/statistics/icon-receive.png">
                            <label>当年总收款</label>
                            <span class="value">￥<el-statistic group-separator="," :precision="2" :value="price.receive" /></span>
                            <span class=" unit">元</span>
                        </div>
                        <div @click="showDeposit">
                            <img src="~@/assets/image/statistics/icon-deposit.png">
                            <label>待收保证金</label>
                            <span class="value">￥<el-statistic group-separator="," :precision="2" :value="price.deposit" /></span>
                            <span class=" unit">元</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="height: 640px;">
                <el-col :span="10" v-loading="loadProduct">
                    <!-- 模块：客户分布 -->
                    <div class="statis-wrap">
                        <div class="title-line">
                            <div class="title">当年产品统计</div>
                        </div>
                        <!-- 三个卡片 -->
                        <ul class="order-card">
                            <li :class="{'active': key == productType}" v-for="(val, key) in productTypeMap" :key="key" @click="productType = key">
                                <label>{{ val.name }}</label>
                                <span class="value">{{ val.count }}</span>
                                <span class="unit">个</span>
                            </li>
                        </ul>
                        <!-- 表格数据 -->
                        <el-table :data="productTypeMap[productType].dataList" :max-height="productType == 3 ? '438px' : '396px'"
                            :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }" :row-class-name="productTableClassName">
                            <template v-if="productType == 3">
                                <el-table-column prop="productName" label="产品类型" min-width="140" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="customerCount" label="客户数量" min-width="90">
                                    <template slot-scope="{row}">
                                        <span v-if="row.productName === '合计'">{{ row.customerCount }}</span>
                                        <span v-else class="link" @click="showCovenantDetailByProduct(row.productId)">{{ row.customerCount }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="newCount" label="当年新订客户" min-width="110"></el-table-column>
                                <el-table-column prop="currentCount" label="当年续订客户" min-width="110"></el-table-column>
                                <el-table-column prop="pastCount" label="往年订购客户" min-width="110"></el-table-column>
                            </template>
                            <template v-else>
                                <el-table-column prop="productName" label="产品类型" min-width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="customerCount" label="合同数量" width="80">
                                    <template slot-scope="{row}">
                                        <span class="link" @click="showCovenantDetailByProduct(row.productId)">{{ row.customerCount }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="contractPrice" label="合同金额(万元)" min-width="120"></el-table-column>
                                <el-table-column prop="invoicePrice" label="开票金额(万元)" min-width="120"></el-table-column>
                                <el-table-column prop="receivePrice" label="到账金额(万元)" min-width="120"></el-table-column>
                            </template>
                        </el-table>
                        <!-- 说明文字 -->
                        <div v-if="productType == 3" class="red-text">
                            <i class="el-icon-warning-outline"></i>说明：合计是按照产品统计客户数量，一个客户可能订购多个产品，这里未做去重处理，所以无法点击查看。
                        </div>
                        <div v-else-if="productTypeMap[productType].count != productTypeMap[productType].totalCount" class="red-text">
                            <i class="el-icon-warning-outline"></i>说明：为何合计数量为{{productTypeMap[productType].count}}，而非{{productTypeMap[productType].totalCount}}
                            ？因为存在1份合同可能包含多个产品。<br />
                            按产品统计：统计产品出现在多少份合同中（合同可能重复计算），统计结果为{{productTypeMap[productType].totalCount}}。<br />
                            按合同统计：统计不重复的实际合同份数，统计结果为{{productTypeMap[productType].count}}。
                        </div>
                    </div>
                </el-col>
                <el-col :span="14">
                    <!-- 模块：排行榜 -->
                    <div class="statis-wrap">
                        <!-- 标题+筛选 -->
                        <div class="title-line" style="margin-bottom: 12px;">
                            <div class="title">当年销售情况</div>
                            <div v-if="salesData.length" class="label-flex">
                                <div class="label-box" style="color: #409eff;">
                                    <img src="~@/assets/image/statistics/price-target.png" height="16px">
                                    <span>总目标：<b>{{ salesText.totalTargetPrice }}</b>万元</span>
                                </div>
                                <div class="label-box" style="color: #ff8704;">
                                    <img src="~@/assets/image/statistics/price-contract.png" height="16px">
                                    <span>已完成：<b>{{ salesText.totalContractPrice }}</b>万元</span>
                                </div>
                                <div class="label-box shadow" style="color: #0540c3;">
                                    <img src="~@/assets/image/statistics/price-complete.png" height="16px">
                                    <span>达成率：<b>{{ salesText.totalRate }}</b>%</span>
                                </div>
                            </div>
                            <CardSwitch v-model="yearType" :styleType="2" :options="[{id:1,name:'农历年'}, {id:2,name:'自然年'}]" @change="fetchSalesProgress" />
                        </div>
                        <!-- 轮播图 -->
                        <moduleSales v-if="salesData.length" :dataList="salesData" @openCovenant="showSalesCovenant" @openInvoice="showSalesInvoice"
                            v-loading="loadSales" />
                        <!-- 空数据 -->
                        <div class="empty-wrap" v-else>
                            <img src="~@/assets/image/emptyBlue.png" alt="">
                        </div>
                        <!-- 说明文字 -->
                        <div v-if="yearType === 1" class="red-text" style="margin-top: 20px;">
                            <i class="el-icon-warning-outline"></i>说明：农历年{{ salesText.year }}，起止日期为{{ salesText.startDate }}（正月初一）至{{ salesText.endDate }}（腊月廿九）
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 合同详情 -->
        <covenantDetail :visible.sync="covenantVisible" :params="covenantFilters" :latestTime="covenantLatestTime" />
        <!-- 开票详情 -->
        <invoiceDetail :visible.sync="invoiceVisible" :params="invoiceFilters" :latestTime="invoiceLatestTime" />
        <!-- 保证金详情 -->
        <depositDetail :visible.sync="depositVisible" :params="depositFilters" />
    </div>
</template>

<script>
import {
    findPriceAndCustomerStatistics,
    findCustomerStatistics,
    findSaleConditionList,
    findLatestContractDataTime, findLatestContractPayDataTime,
} from '@/api/statistics/index.js';
import { mapState } from 'vuex';

export default {
    components: {
        moduleSales: () => import("./components/moduleSales.vue"),
        covenantDetail: () => import("./components/covenantDetail.vue"),
        invoiceDetail: () => import("./components/invoiceDetail.vue"),
        depositDetail: () => import("./components/depositDetail.vue"),
        lineBarChar: () => import("./components/lineBarChar.vue"),
    },
    data() {
        return {
            filters: {
                saleUserId: '',
                productId: '',
                year: '',
            },
            // -----------历年合同统计-----------
            loadTrend: false,
            trendMonthFlag: 0, // 1-月度 | 0-年度
            trendSwitch: 'table',
            trendChartData: [],
            trendTableData: [],
            // 右侧四个统计
            price: {
                count: 0,
                contract: 0,
                invoice: 0,
                receive: 0,
                deposit: 0
            },
            // -----------产品统计-----------
            loadProduct: false,
            productType: 1,
            productTypeMap: {
                1: { name: '新订合同', count: 0, dataList: [] },
                2: { name: '续订合同', count: 0, dataList: [] },
                3: { name: '客户数量', count: 0, dataList: [] }
            },
            // -----------销售情况-----------
            loadSales: false,
            yearType: 1,
            salesData: [],
            salesText: { // 说明文字
                year: '',
                startDate: '',
                endDate: '',
                totalTargetPrice: 0,
                totalContractPrice: 0,
                totalRate: 0,
            },
            // -----------合同详情-----------
            covenantVisible: false,
            covenantFilters: {},
            covenantLatestTime: '',
            // -----------开票详情-----------
            invoiceVisible: false,
            invoiceFilters: {},
            invoiceLatestTime: '',
            // -----------保证金-----------
            depositVisible: false,
            depositFilters: {},
        }
    },
    computed: {
        ...mapState(["userData", "productList", "mySaleUserOptions", "yearOptions"]),
        // 历年合同统计 -> 表格
        getTrendTableData() {
            if (this.trendMonthFlag === 0) {
                return [...this.trendTableData].reverse()
            } else {
                return this.trendTableData
            }
        }
    },
    created() {
        if (this.userData.type === 0 || this.userData.type === 1) {
            // 当前登录的账号是不是销售，0-区域经理，1-大区经理
            this.filters.saleUserId = this.userData.userId;
        }
        this.filters.year = new Date().getFullYear();
        this.initData();
        this.getLatestContractDataTime();
        this.getLatestContractPayDataTime();
    },
    methods: {
        initData() {
            this.fetchOveryearTrend(); // 历年趋势
            this.fetchCustomer(); // 客户分布
            this.fetchSalesProgress(); // 销售情况
        },
        // 查数据: 历年趋势
        fetchOveryearTrend() {
            this.loadTrend = true;
            findPriceAndCustomerStatistics({ ...this.filters, monthFlag: this.trendMonthFlag }).then(res => {
                this.price = {
                    count: res.data.customerCount || 0,
                    contract: Number(res.data.contractPrice) || 0,
                    invoice: Number(res.data.invoicePrice) || 0,
                    receive: Number(res.data.receivePrice) || 0,
                    deposit: Number(res.data.needRefundPrice) || 0,
                };
                // 表格
                this.trendTableData = res.data.itemList
                // 趋势图
                this.trendChartData = [];
                let yue = this.trendMonthFlag == 1 ? '月' : '';
                res.data.itemList.forEach(item => {
                    if (item.value !== '合计') {
                        this.trendChartData.push({ name: item.value + yue, value: item.contractPrice || 0, tip: '合同金额' });
                        this.trendChartData.push({ name: item.value + yue, value: item.invoicePrice || 0, tip: '合同已开票' });
                        this.trendChartData.push({ name: item.value + yue, value: item.customerCount || 0, tip: '合同数量' });
                    }
                })
                this.loadTrend = false;
            }).catch(err => {
                if (err.status === 888) return;
                this.price = {
                    count: 0,
                    contract: 0,
                    invoice: 0,
                    receive: 0,
                    deposit: 0,
                };
                this.trendTableData = [];
                this.trendChartData = [];
                this.loadTrend = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 查数据: 客户分布
        fetchCustomer() {
            this.loadProduct = true;
            findCustomerStatistics({
                ...this.filters,
            }).then(res => {
                let { newCount, newTotalCount, currentCount, currentTotalCount, customerCount, customerList } = res.data
                let newList = res.data.newList.map(x => {
                    return {
                        ...x,
                        contractPrice: this.getTransWanyuan(x.contractPrice),
                        invoicePrice: this.getTransWanyuan(x.invoicePrice),
                        receivePrice: this.getTransWanyuan(x.receivePrice),
                    }
                })
                let currentList = res.data.currentList.map(x => {
                    return {
                        ...x,
                        contractPrice: this.getTransWanyuan(x.contractPrice),
                        invoicePrice: this.getTransWanyuan(x.invoicePrice),
                        receivePrice: this.getTransWanyuan(x.receivePrice),
                    }
                })
                // 统计数量
                this.productTypeMap = {
                    1: { name: '新订合同', count: newCount, dataList: newList, totalCount: newTotalCount },
                    2: { name: '续订合同', count: currentCount, dataList: currentList, totalCount: currentTotalCount },
                    3: { name: '客户数量', count: customerCount, dataList: customerList }
                };
                this.loadProduct = false;
            }).catch(err => {
                if (err.status === 888) return;
                this.productTypeMap = {
                    1: { name: '新订合同', count: 0 },
                    2: { name: '续订合同', count: 0 },
                    3: { name: '客户数量', count: 0 }
                };
                this.loadProduct = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 产品统计：表格“合计”行高亮
        productTableClassName({ row }) {
            if (row.productName === '合计') {
                return 'total-row';
            }
            return '';
        },
        // 元转为万元
        getTransWanyuan(yuan) {
            if (yuan > 0) {
                // 将元转换为万元
                let tenThousandYuan = (yuan / 10000).toFixed(2);
                // 去除尾随的".00"（如果存在）
                tenThousandYuan = tenThousandYuan.replace(/\.0+$|(\.\d+?)0+$/, '$1');

                return tenThousandYuan;
            } else {
                return 0
            }
        },
        // 查数据: 销售情况
        fetchSalesProgress() {
            this.loadSales = true;
            findSaleConditionList({
                ...this.filters,
                yearType: this.yearType
            }).then(res => {
                this.salesData = res.data.saleList?.map(x => {
                    return {
                        ...x,
                        rate: x.rate ? Number(x.rate) : 0
                    }
                }) || [];
                this.salesText.year = res.data.year;
                this.salesText.startDate = res.data.startDate;
                this.salesText.endDate = res.data.endDate;
                this.salesText.totalTargetPrice = res.data.totalTargetPrice;
                this.salesText.totalContractPrice = res.data.totalContractPrice;
                this.salesText.totalRate = res.data.rate;
                this.loadSales = false;
            }).catch(err => {
                this.loadSales = false;
                this.salesData = [];
                this.salesText.year = '';
                this.salesText.startDate = '';
                this.salesText.endDate = '';
                this.salesText.totalTargetPrice = 0;
                this.salesText.totalContractPrice = 0;
                this.salesText.totalRate = 0;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 产品统计 -> 点击“订购数量”显示合同详情
        showCovenantDetailByProduct(productId) {
            if (this.$utils.isMobile()) return;
            if (this.productType == 1) {
                this.covenantFilters = {
                    ...this.filters,
                    productId: productId ? productId : ''
                };
                this.covenantFilters.contractType = 1
                this.covenantVisible = true;
            } else if (this.productType == 2) {
                this.covenantFilters = {
                    ...this.filters,
                    productId: productId ? productId : ''
                };
                this.covenantFilters.contractType = 2
                this.covenantVisible = true;
            } else if (this.productType == 3) {
                this.$router.push({
                    path: '/customer',
                    query: {
                        productId: productId ? productId : '',
                        orderType: '1',
                        saleUserId: this.filters.saleUserId,
                        statusList: '0,1',
                    }
                });
            }
        },
        // 点击显示合同详情：invoiceFlag(0-未开票 | 1-已开票 | 2-部分开票)
        showCovenantDetail(value = '', invoiceList = []) {
            if (this.$utils.isMobile()) return;
            this.covenantVisible = true;
            this.covenantFilters = { ...this.filters };
            this.covenantFilters.invoiceList = invoiceList
            if (value && value.toString().length === 4) {
                this.covenantFilters.year = value
            } else if (value !== '合计') {
                this.covenantFilters.month = value
            }
        },
        // 点击显示开票详情：statisticsType(0-按开票日期统计 | 1-按到账日期统计)，receiveFlag(0-未到账 | 1-已到账)
        showInvoiceDetail(statisticsType, value = '', receiveFlag = '') {
            if (this.$utils.isMobile()) return;
            this.invoiceVisible = true;
            this.invoiceFilters = {
                ...this.filters,
                statisticsType,
                receiveFlag
            };
            if (value && value.toString().length === 4) {
                this.invoiceFilters.year = value
            } else if (value !== '合计') {
                this.invoiceFilters.month = value
            }
        },
        // 销售情况：打开合同详情
        showSalesCovenant(saleUserId, contractType) {
            this.covenantVisible = true;
            this.covenantFilters = {
                ...this.filters,
                saleUserId,
                contractType,
            };
            if (this.yearType === 1) {
                this.covenantFilters.signDate = []
                let startDate = this.salesText.startDate.replace('年', '-').replace('月', '-').replace('日', '')
                let endDate = this.salesText.endDate.replace('年', '-').replace('月', '-').replace('日', '')
                this.covenantFilters.signDate[0] = this.$utils.formatDate(new Date(startDate), 'yyyy-MM-dd');
                this.covenantFilters.signDate[1] = this.$utils.formatDate(new Date(endDate), 'yyyy-MM-dd');
            }
        },
        // 销售情况：打开开票详情
        showSalesInvoice(saleUserId, statisticsType) {
            this.invoiceVisible = true;
            this.invoiceFilters = {
                ...this.filters,
                saleUserId,
                statisticsType
            };
            if (this.yearType === 1) {
                this.invoiceFilters.signDate = []
                let startDate = this.salesText.startDate.replace('年', '-').replace('月', '-').replace('日', '')
                let endDate = this.salesText.endDate.replace('年', '-').replace('月', '-').replace('日', '')
                this.invoiceFilters.signDate[0] = this.$utils.formatDate(new Date(startDate), 'yyyy-MM-dd');
                this.invoiceFilters.signDate[1] = this.$utils.formatDate(new Date(endDate), 'yyyy-MM-dd');
            }
        },
        // 获取合同数据最新更新时间
        getLatestContractDataTime() {
            findLatestContractDataTime().then(res => {
                this.covenantLatestTime = res.data;
            }).catch(err => {
                console.log(`!!ERROR!!合同数据最新更新时间获取失败`, err.data.msg);
            })
        },
        // 获取开票数据最新更新时间
        getLatestContractPayDataTime() {
            findLatestContractPayDataTime().then(res => {
                this.invoiceLatestTime = res.data;
            }).catch(err => {
                console.log(`!!ERROR!!开票数据最新更新时间获取失败`, err.data.msg);
            })
        },
        // 保证金：打开弹窗
        showDeposit() {
            this.depositVisible = true;
            this.depositFilters.saleUserId = this.filters.saleUserId;
        }
    }
}
</script>

<style lang="scss" scoped>
.page-statistics {
    min-width: 1400px;
    width: 80%;
    margin: 0 auto;
    padding-top: $pc-header-height;
    min-height: calc(100vh - #{$pc-header-height});
    padding-bottom: 4rem;
    .filters-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 20px;
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
        /deep/ .filter-line:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .prompt {
            position: absolute;
            right: 20px;
            bottom: 12px;
            color: #7c7c7c;
            font-size: 14px;
            b {
                color: #222;
            }
        }
    }
    .statistics-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        > .el-row > .el-col {
            height: 100%;
        }
        .statis-wrap {
            height: 100%;
            padding: 15px;
            background-color: #fff;
            border-radius: 10px;
            box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
            .title-line {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 36px;
                margin-bottom: 25px;
                padding-bottom: 11px;
                border-bottom: 1px solid #f1f1f1;
                &::before {
                    content: "";
                    position: absolute;
                    bottom: -1px;
                    left: 0;
                    display: inline-block;
                    width: 80px;
                    height: 5px;
                    background-image: url("~@/assets/image/statistics/title-underline.png");
                    background-size: contain;
                    background-repeat: no-repeat;
                }
                .title {
                    color: #111112;
                    font-size: 18px;
                    font-weight: 600;
                }
            }
            .empty-wrap {
                min-height: 520px;
                padding-top: 8rem;
                text-align: center;
                > img {
                    width: 24rem;
                }
            }
            .order-card {
                display: flex;
                gap: 20px;
                margin-bottom: 20px;
                list-style: none;
                > li {
                    display: flex;
                    align-items: center;
                    width: calc(100% / 3);
                    height: 60px;
                    padding: 0 10px 0 8px;
                    color: $primary-font-color;
                    background-color: #f4f4f4;
                    border: 2px solid #f4f4f4;
                    border-radius: 10px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    white-space: nowrap;
                    label {
                        font-family: "黑体";
                        font-size: 17px;
                        cursor: pointer;
                    }
                    .value {
                        margin-left: auto;
                        margin-right: 3px;
                        font-size: 18px;
                    }
                    .unit {
                        padding-top: 2px;
                        font-size: 14px;
                        font-weight: 400;
                    }
                    &::before {
                        content: "";
                        display: inline-block;
                        width: 30px;
                        height: 30px;
                        margin-right: 10px;
                        background-repeat: no-repeat;
                        background-size: contain;
                    }
                    &:first-of-type {
                        &::before {
                            background-image: url("~@/assets/image/statistics/icon-new.png");
                        }
                        &.active {
                            color: #67c23a;
                            border-color: #67c23a;
                            background-color: rgba(#67c23a, 0.08);
                            &::before {
                                background-image: url("~@/assets/image/statistics/icon-new-active.png");
                            }
                        }
                    }
                    &:nth-of-type(2) {
                        &::before {
                            background-image: url("~@/assets/image/statistics/icon-renew.png");
                        }
                        &.active {
                            color: #409eff;
                            border-color: #409eff;
                            background-color: rgba(#409eff, 0.08);
                            &::before {
                                background-image: url("~@/assets/image/statistics/icon-renew-active.png");
                            }
                        }
                    }
                    &:last-of-type {
                        &::before {
                            background-image: url("~@/assets/image/statistics/icon-past.png");
                        }
                        &.active {
                            color: #fba249;
                            border-color: #fba249;
                            background-color: rgba(#fba249, 0.08);
                            &::before {
                                background-image: url("~@/assets/image/statistics/icon-past-active.png");
                            }
                        }
                    }
                }
            }
            .red-text {
                margin-top: 12px;
                color: #f53f3f;
                font-size: 0.9rem;
                line-height: 1.3rem;
                i {
                    margin-right: 2px;
                    font-size: 1rem;
                    vertical-align: -1px;
                }
                b {
                    margin: 0 2px;
                }
            }
            .label-flex {
                margin-left: 20px;
                margin-right: auto;
                display: flex;
                gap: 30px;
                font-size: 14px;
                font-weight: 600;
                .label-box {
                    display: flex;
                    gap: 4px;
                    align-items: center;
                    &.shadow {
                        padding: 3px 10px;
                        background-color: #EBF0FA;
                        border-radius: 6px;
                    }
                }
            }
        }
        .full-card {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 0 18px;
            color: #fff;
            > div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 60px;
                padding: 0 15px;
                background-color: rgba(255, 255, 255, 0.15);
                border-radius: 10px;
                cursor: pointer;
            }
            img {
                width: 36px;
                height: 36px;
                margin-right: 10px;
            }
            label {
                margin-right: auto;
                font-size: 18px;
                font-weight: 600;
                cursor: pointer;
            }
            .value {
                display: inline-flex;
                align-items: center;
                font-size: 20px;
                font-weight: 600;
                /deep/ .el-statistic {
                    display: inline-block;
                    .con {
                        color: #fff;
                        .number {
                            padding: 0;
                        }
                    }
                }
            }
            .unit {
                margin-left: 5px;
                font-size: 16px;
            }
        }
    }
}
/deep/ .radius-input {
    margin: 15px 0;
    .el-input__inner {
        height: 34px;
        line-height: 34px;
        border-radius: 20px;
        font-size: 14px;
    }
    .el-input__icon {
        line-height: 34px;
    }
}
/deep/ .el-table .total-row {
    background: #f2f3f5;
}

.link {
    color: #0440c3;
    cursor: pointer;
}
</style>